

// import React from "react";
// import SEO from "../components/SEO.jsx";
// import Header from "../partials/header/Header.jsx";
// import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import Footer from "../container/Footer/Footer";
// import ScrollToTop from "../components/ScrollToTop.jsx";
// import ContactFromContainer from "../container/ContactFromContainer/ContactFromContainer.js";

// const Consultation = () => {
//     return (
//         <React.Fragment>
//             <SEO title="Tawanai || EnergyTech" />
//             <Header />
//             <Breadcrumb
//                 image="images/bg/bg1.webp"
//                 title="Tawanai"
//                 content="Home"
//                 contentTwo="Request Consultation"
//             />

//             {/* <div style={{ padding: "7%" }}>
//                 ko
//             </div> */}
//               <ContactFromContainer />

//             <Footer />
//             <ScrollToTop />
//         </React.Fragment>
//     );
// };

// export default Consultation;



// import React from "react";
// import SEO from "../components/SEO.jsx";
// import Header from "../partials/header/Header.jsx";
// import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import Footer from "../container/Footer/Footer";
// import ScrollToTop from "../components/ScrollToTop.jsx";
// import SectionTitle from "../components/SectionTitles/SectionTitle";

// const Consultation = () => {
//   return (
//     <React.Fragment>
//       <SEO title="Tawanai || EnergyTech" />
//       <Header />

//       <Breadcrumb
//         image="images/bg/bg1.webp"
//         title="Tawanai"
//         content="Home"
//         contentTwo="Consult Us"
//       />

//       {/* CONSULTATION FORM SECTION */}
//       <div className="contact-form-section section section-padding-t90-b100 bg-primary-blue">
//         <div className="container">
//           <div className="row">
//             <div className="offset-lg-2 col-lg-8">

//               <SectionTitle
//                 headingOption="fz-32"
//                 title="Consult With Our Experts"
//                 subTitle="Share your project details and our team will get in touch"
//               />

//               <div className="contact-form" data-aos="fade-up" data-aos-delay="300">
//                 <form>
//                   <div className="row mb-n6">

//                     <div className="col-md-6 col-12 mb-6">
//                       <input
//                         type="text"
//                         placeholder="Full Name *"
//                         name="name"
//                       />
//                     </div>

//                     <div className="col-md-6 col-12 mb-6">
//                       <input
//                         type="email"
//                         placeholder="Work Email *"
//                         name="email"
//                       />
//                     </div>

//                     <div className="col-md-6 col-12 mb-6">
//                       <input
//                         type="text"
//                         placeholder="Company"
//                         name="company"
//                       />
//                     </div>

//                     <div className="col-md-6 col-12 mb-6">
//                       <input
//                         type="text"
//                         placeholder="Project Location"
//                         name="location"
//                       />
//                     </div>

//                     <div className="col-md-12 col-12 mb-6">
//                       <input
//                         type="text"
//                         placeholder="Service of Interest"
//                         name="service"
//                       />
//                     </div>

//                     <div className="col-12 mb-6">
//                       <textarea
//                         name="message"
//                         placeholder="Briefly describe your project or requirements"
//                       ></textarea>
//                     </div>

//                     <div className="col-12 text-center mb-6">
//                       <button
//                         type="submit"
//                         className="btn btn-primary btn-hover-secondary"
//                       >
//                         Consult Us
//                       </button>
//                     </div>

//                   </div>
//                 </form>
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>

//       <Footer />
//       <ScrollToTop />
//     </React.Fragment>
//   );
// };

// export default Consultation;


import React from "react";
import SEO from "../components/SEO.jsx";
import Header from "../partials/header/Header.jsx";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import SectionTitle from "../components/SectionTitles/SectionTitle";

const inputStyle = {
  width: "100%",
  height: "56px",
  padding: "14px 18px",
  fontSize: "15px",
  fontFamily: "inherit",
  color: "#666",
  backgroundColor: "#f5f5f5",
  border: "1px solid transparent",
  borderRadius: "6px",
  outline: "none",
  boxShadow: "none",
};

const textareaStyle = {
  ...inputStyle,
  height: "140px",
  resize: "none",
};

const Consultation = () => {
  return (
    <React.Fragment>
      <SEO title="Tawanai || EnergyTech" />
      <Header />

      <Breadcrumb
        image="images/bg/bg1.webp"
        title="Tawanai"
        content="Home"
        contentTwo="Consult Us"
      />

      {/* CONSULTATION FORM SECTION */}
      <div className="contact-form-section section section-padding-t90-b100 bg-primary-blue">
        <div className="container">
          <div className="row">
            <div className="offset-lg-2 col-lg-8">

              <SectionTitle
                headingOption="fz-32"
                title="Consult With Our Experts"
                subTitle="Share your project details and select a preferred time to connect"
              />

              <div
                className="contact-form"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <form>
                  <div className="row mb-n6">

                    <div className="col-md-6 col-12 mb-6">
                      <input
                        type="text"
                        placeholder="Full Name *"
                        name="name"
                        style={inputStyle}
                      />
                    </div>

                    <div className="col-md-6 col-12 mb-6">
                      <input
                        type="email"
                        placeholder="Work Email *"
                        name="email"
                        style={inputStyle}
                      />
                    </div>

                    <div className="col-md-6 col-12 mb-6">
                      <input
                        type="text"
                        placeholder="Company"
                        name="company"
                        style={inputStyle}
                      />
                    </div>

                    <div className="col-md-6 col-12 mb-6">
                      <input
                        type="text"
                        placeholder="Project Location"
                        name="location"
                        style={inputStyle}
                      />
                    </div>

<div className="col-md-6 col-12 mb-6">
                      <input
                        type="text"
                         placeholder="Service of Interest"
                        name="service"
                        style={inputStyle}
                      />
                    </div>

                  

                    {/* DATE & TIME PICKER — INLINE STYLED */}
                    <div className="col-md-6 col-12 mb-6">
                      <input
                        type="datetime-local"
                        name="preferredDateTime"
                        style={{
                          ...inputStyle,
                          color: "#999",
                          cursor: "pointer",
                        }}
                      />
                    </div>


                    <div className="col-12 text-center mb-6">
                      <button
                        type="submit"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Consult Us
                      </button>
                    </div>

                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Consultation;